<template>
  <div id="top">
    <Scaffold v-if="env == 'production'">
      <NavbarDefault
        v-if="blok?.navbar[0]"
        :categories="blok.navbar[0].categories"
        :sideBtn="blok.navbar[0].sideBtn?.[0]"
      />
      <div class="error-page">
        <StoryblokImg
          :image="{
            filename:
              'https://a.storyblok.com/f/223704/1441x419/52ac3095b3/404.svg',
            alt: t('image.alt'),
          }"
          width="1440"
          height="420"
          class="error-image"
        />
        <GridContainer>
          <GridItem
            class="text-container"
            :size-lg="6"
            :offset-lg="3"
            :size-xl="6"
            :offset-xl="3"
          >
            <h2>{{ t(`title.${blok ? "default" : "fatal"}`) }}</h2>
            <p>{{ t(`description.${blok ? "default" : "fatal"}`) }}</p>
            <CjaButton
              :color="'orange'"
              href="/"
              :alt-anchor="NuxtLink"
              v-if="blok"
            >
              {{ t("btn") }}
            </CjaButton>
          </GridItem>
        </GridContainer>
      </div>
      <FooterDefault
        v-if="blok?.footer && blok?.footer[0]"
        :footer="blok.footer[0]"
      />
    </Scaffold>
    <GridContainer v-else>
      <GridItem
        :size-lg="8"
        :offset-lg="2"
        :size-xl="8"
        :offset-xl="2"
        class="error-container"
      >
        <pre class="error-message">{{ error.message }}</pre>
        <div v-html="error.stack"></div>
      </GridItem>
    </GridContainer>
  </div>
</template>

<script lang="ts" setup>
import { NuxtLink } from "#components";
import { CjaButton, GridContainer, GridItem, Scaffold } from "cja-phoenix";

const props = defineProps<{ error: any }>();

const { blok } = await useStoryblokContent({
  path: "config/default-layout",
});

const { t } = useI18n();

useHead({
  title: t("title.default"),
});

const { env } = useRuntimeConfig().public;

console.error(props.error);
</script>

<style lang="scss" scoped>
.error-page {
  padding-top: 32px;

  @media screen and (min-width: $break-md-min) {
    padding-top: 56px;
  }

  .error-image {
    display: block;
    width: 100%;
  }

  .text-container {
    padding-top: 32px;
    padding-bottom: 32px;
    text-align: center;

    @media screen and (min-width: $break-md-min) {
      padding-top: 56px;
      padding-bottom: 56px;
    }

    h2 {
      text-align: center;
      font-size: 30px;
      line-height: 36px;
      font-weight: 800;
      @include text-gradient-dark-blue;
      margin: 0 0 32px;
    }

    p {
      font-size: 18px;
      line-height: 22px;
      margin: 0 0 24px;

      @media screen and (min-width: $break-md-min) {
        font-size: 24px;
        line-height: 36px;
        margin: 0 0 40px;
      }
    }
  }
}

.error-container {
  background: $dark-white;
  border: 1px solid $light-grey;
  padding: 16px;
  border-radius: 8px;
  margin: 64px 0;

  .error-message {
    font-size: 14px;
    margin-bottom: 8px;
  }

  :deep(pre) {
    margin: 0;
  }
}
</style>

<i18n lang="json">
{
  "pt": {
    "title": {
      "default": "Oooops, algo correu mal!",
      "fatal": "Encontramo-nos em manutenção"
    },
    "description": {
      "default": "Ocorreu um erro inesperado. Esta página não se encontra disponível neste momento.",
      "fatal": "Estamos a trabalhar para voltar ao funcionamento normal."
    },
    "image": {
      "alt": "Detetamos um erro"
    },
    "btn": "Voltar ao início"
  }
}
</i18n>
